import { Button, Grid, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Modal } from '../../../common/components/utils/Modal';
import { formatSql } from '../../../common/utilFunctions/sqlFormatter';
import { getAliasForMetricGroupId } from '../../../common/v2/api/alias/utils';
import {
  useAliasesContext,
  useGlobalLocaleContext,
  useLegacyDomainScopedStoresContext,
} from '../../../common/v2/context/contexts';
import { getDisplayMetricGroupName } from './translations';
import { MetaDataObject } from './types';

interface MetricQueryMetaDataProps {
  open: boolean;
  metaDataObject: MetaDataObject | null;
  onClose: () => void;
}

export const MetricQueryMetaData = (props: MetricQueryMetaDataProps) => {
  const aliases = useAliasesContext();
  const locale = useGlobalLocaleContext();
  const selectedLanguage = locale.selected;
  const { open, metaDataObject, onClose } = props;
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const legacyDomainScopedStores = useLegacyDomainScopedStoresContext();
  const { metricStore } = legacyDomainScopedStores;
  if (!metaDataObject) {
    return null;
  }
  const { metricGroupId, metricId, metricSql } = metaDataObject;
  const alias = getAliasForMetricGroupId(
    aliases,
    selectedLanguage
  )(metricGroupId);

  const handleCopySQL = () => {
    if (metricSql) {
      navigator.clipboard.writeText(formatSql(metricSql));
      setShowCopiedTooltip(true);
      setTimeout(() => setShowCopiedTooltip(false), 2000);
    }
  };

  return (
    <Modal title="Query MetaData" open={open} onClose={onClose}>
      <Grid sx={{ padding: 4 }}>
        <Typography variant="h6">{`Metric ID: ${metricId}`}</Typography>
        <Typography variant="h6">{`PBS Item: ${getDisplayMetricGroupName(
          metricGroupId,
          alias,
          metricStore
        )}`}</Typography>
        <Typography variant="h6">{`PBS Measure: ${metricStore.getTranslatedMetricIdName(metricId)}`}</Typography>
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Typography variant="body1">
            <i>
              <strong>SQL</strong>
            </i>
          </Typography>
          {metricSql && (
            <Tooltip title="Copied!" open={showCopiedTooltip} arrow>
              <Button variant="outlined" size="small" onClick={handleCopySQL}>
                Copy SQL
              </Button>
            </Tooltip>
          )}
        </div>
        <Typography variant="body2" sx={{ color: 'brown' }}>
          {metricSql ? (
            <pre style={{ whiteSpace: 'pre-wrap' }}>{formatSql(metricSql)}</pre>
          ) : (
            'No metric SQL available'
          )}
        </Typography>
      </Grid>
    </Modal>
  );
};
